import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { commonAction } from "../../../../redux/features/commonSlice";
import { useFormik } from "formik";
import CloseIcon from "../../../../components/icons/CloseIcon";
import { CommonEnums } from "../../../../enums/common.enums";
import FilterDates from "./FilterDates";
import FixDataFilterSelector from "./FixDataFilterSelector";
import "./AgencyAgentEmployeeFilter.scss";
import FilterAgentSearch from "./FilterAgentSearch";

interface AgencyAgentEmployeeFilterProps {
  initialFilterValues: any;
  onApply: (values: any) => void;
}

const AgencyAgentEmployeeFilter = ({
  initialFilterValues,
  onApply,
}: AgencyAgentEmployeeFilterProps) => {
  const dispatch = useDispatch();

  const homePageFilter = useSelector(
    (state: RootState) => state?.common?.homePageFilter,
  );

  const onCloseFilter = () => {
    dispatch(commonAction.setHomePageFilter());
  };

  const formik = useFormik({
    initialValues: initialFilterValues,
    enableReinitialize: true,
    onSubmit: (values) => {
      onApply(values);
      onCloseFilter();
    },
  });

  const onClickClear = () => {
    const emptyValues = {
      brand_country: "",
      status: "",
      startDate: "00-00-00",
      endDate: "00-00-00",
    };

    formik.setValues(emptyValues);
    onApply(emptyValues);
    onCloseFilter();
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <div
        className={`invites-filter-container ${
          homePageFilter ? "" : "deactivate-filter"
        }`}
      >
        {homePageFilter && (
          <div className="filter-background" onClick={onCloseFilter}></div>
        )}

        <div
          className={`invites-filter-box ${
            homePageFilter ? "" : "deactivate-filter"
          }`}
        >
          <div className="filter-top-heading">
            <p className="filter-top-head">Filters</p>
            <div className="filter-close-icon" onClick={onCloseFilter}>
              <CloseIcon />
            </div>
          </div>

          <div className="filter-body-container">
            <div className="filter-selector-container">
              <FilterAgentSearch formik={formik} />
            </div>

            <div className="filter-selector-container">
              <FixDataFilterSelector
                formik={formik}
                type={CommonEnums.selectorType?.status}
                placeholder="Status"
              />
            </div>

            <FilterDates formik={formik} />
          </div>

          <div className="action-btn">
            <button
              type="button"
              className="clear-filters-btn"
              onClick={onClickClear}
            >
              Clear Filters
            </button>

            <button type="submit" className="apply-btn">
              Apply
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default AgencyAgentEmployeeFilter;
